var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDroneIconRegen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#2563eb",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12a9 9 0 0 1-9 9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12a9 9 0 0 1 9-9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3v6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21v-6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15l-3-3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15l3-3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroneIconRegen);
export default __webpack_public_path__ + "static/media/drone-icon-regen.f951df9d1c13730537df5dfe4f2e27d8.svg";
export { ForwardRef as ReactComponent };